import { Chip } from '@mui/material';

export function BaseChip({ count = 0, icon, onClick, sx = {}, disabled }) {   
    return (
        <Chip
            disabled={disabled}
            variant="outlined"
            icon={icon}
            label={count > 0 ? count : undefined}
            onClick={onClick}
            sx={{
                border: '0px',
                justifyContent: 'left',
                cursor: onClick ? 'pointer' : 'default',
                ...sx
            }}
        />
    );
}